import TwoFactorAuth from './two-factor-auth';

export type TwoFactorLoginProps = {
    error?: string
    handleConfirmVerification: (value: string) => void;
    handleResendTwoFa: () => void;
    isMutating: boolean
}

export default function TwoFactorLogin({ error, handleConfirmVerification, handleResendTwoFa, isMutating }: TwoFactorLoginProps) {

    return (
        <>
            <img
                src={'/assets/Logo-Atarim-Login.svg'}
                className="mb-6 block w-[180px] lg:hidden"
                alt="Logo"
            />
            <div className="grid gap-2 text-center">
                <h1 className="text-3xl font-bold text-textcolor">Login</h1>
                <p className="font-base flex justify-center self-center text-balance text-base text-[#71717a]">
                    Two-Factor Authentication Required
                </p>
                <div className="mb-3 mt-2 text-sm">
                    You have asked us to require a 6-digit login code when anyone tries to
                    access your account from a new device or browser.
                </div>
            </div>
            {error && <div>{error}</div>}
            <div className="w-full">
                <TwoFactorAuth
                    handleConfirmVerification={handleConfirmVerification}
                    //   btnText={'Confirm'}
                    handleResendTwoFa={handleResendTwoFa}
                    isMutating={isMutating}
                />
            </div>
        </>
    );
}
